import Navbar from "./components/Navbar";
import Ticker from "./components/Ticker";
import Hero from "./components/Hero";
import EventFeed from "./components/EventFeed";
import TimelineCase from "./components/TimelineCase";
import Categories from "./components/Categories";
import Responses from "./components/Responses";
import Ranking from "./components/Ranking";
import Principles from "./components/Principles";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <a
        href="#feed"
        className="sr-only focus:not-sr-only focus:absolute focus:left-3 focus:top-3 focus:z-[60] focus:rounded-md focus:bg-primary-500 focus:px-4 focus:py-2 focus:text-sm focus:text-background-50"
      >
        跳到主要内容
      </a>
      <Navbar />
      <Ticker />
      <main>
        <Hero />
        <EventFeed />
        <TimelineCase />
        <Categories />
        <Responses />
        <Ranking />
        <Principles />
        <Testimonials />
        <Faq />
        <ContactSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}